// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9287":"e6a3d1cf66f0ddf4","65031":"16ef54310ad254c5","77628":"20d6bb02fec47021"}[chunkId] + ".css";
};